__turbopack_context__.v({
  "button": "ferP3G_button",
  "copy": "ferP3G_copy",
  "hasCopy": "ferP3G_hasCopy",
  "image": "ferP3G_image",
  "picture": "ferP3G_picture",
  "playPauseButton": "ferP3G_playPauseButton",
  "title": "ferP3G_title",
  "videoBanner": "ferP3G_videoBanner",
  "vimeoContainer": "ferP3G_vimeoContainer",
  "visible": "ferP3G_visible",
});
